export default __webpack_public_path__ + "static/media/audio_gallery.ae4f34d8.svg";